import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'

//API
import * as API  from '../../../../utils/api';

// Form Components
import FormContainer from '../../../../components/Global/FormContainer';
import LockerCampsForm from './LockerCampsForm/LockerCampsForm';

// Flash Message Component
import FlashMessage from '../../../../components/Global/FlashMessage';

class LockerCamps extends Component {
  static propTypes = {
    participation: PropTypes.object
  }

  state ={
    isLoading: true,
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
  }

  componentWillReceiveProps(nextProps) {
    nextProps.participation && this.setState({isLoading: false})
  }

  handleSubmit = (values) => {
    const { user, participation } = this.props

    API.updateParticipation(user, participation, values)
    .then(response => {
      window.scrollTo(0, 0)
      if (response.status === 200) {
        this.setFlashMessage('', 'Changes saved successfully', true)
      } else {
        this.setFlashMessage('error', `Error: ${response.message}`, true)
      }
    })
  }

  setFlashMessage = (type, message, display) => {
    this.setState({
      flashMessage: {
        type,
        message
      },
      displayFlashMessage: display
    })
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    const { isLoading } = this.state
    const { participation } = this.props
    const { trial_active, on_trial } = this.props.activeProfile.trial_info
    const isLocked = on_trial && !trial_active

    return isLoading
    ? null
    : (
      <FormContainer optionalClassName="locker-camps" isLocked={isLocked}>
      {this.renderFlashMessage()}
        <header>
          <h2>Camps</h2>
        </header>
        <LockerCampsForm
          onSubmit={this.handleSubmit}
          participation={participation}
        />
      </FormContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

export default connect(
  mapStateToProps,
  null
)(LockerCamps)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerCamps.js